import { AppProvider, ButtonProps } from '@kcftech/design-system';
import { ReactNode } from 'react';
import * as React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Every link created from the design system will use this LinkComponent
 * to render a link.
 */
const LinkComponent = (props: ButtonProps) => {
    const { external, url, children, onClick, ...rest } = props;
    if (external) {
        return (
            <a
                {...rest}
                onClick={
                    onClick
                        ? (event) =>
                              onClick(
                                  (event as unknown) as React.MouseEvent<
                                      HTMLButtonElement,
                                      MouseEvent
                                  >
                              )
                        : undefined
                }
                href={url}
                target="_blank"
                rel="noopener noreferrer"
            >
                {children}
            </a>
        );
    }
    if (url) {
        return (
            <NavLink
                to={url}
                onClick={
                    onClick
                        ? (event) =>
                              onClick(
                                  (event as unknown) as React.MouseEvent<
                                      HTMLButtonElement,
                                      MouseEvent
                                  >
                              )
                        : undefined
                }
                {...rest}
            >
                {children}
            </NavLink>
        );
    }
    throw new Error(
        'Rendered a link without a URL, is the LinkComponent configured correctly?'
    );
};

export type ConfiguredAppProviderProps = { children?: ReactNode; className?: string };

export function ConfiguredAppProvider({
    children,
    className,
}: ConfiguredAppProviderProps) {
    return (
        <AppProvider linkComponent={LinkComponent} className={className}>
            {children}
        </AppProvider>
    );
}
